// extracted by mini-css-extract-plugin
export default {"container":"SummaryContent_container__4wSHR","heading":"SummaryContent_heading__uHa1+"};